<template>
  <v-dialog :model-value="modelValue" max-width="560" @update:model-value="onDialogUpdate">
    <v-card>
      <v-card-title class="text-h5">User Bug Report</v-card-title>
      <v-card-text>
        <p class="mb-4">In the space below, please be as detailed as possible when describing the bug.</p>
        <v-textarea v-model="description" rows="6" variant="outlined" hide-details autofocus />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="submitting" @click="close">Cancel</v-btn>
        <v-btn color="primary" :loading="submitting" @click="submit">Submit Bug Report</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '../../api/myco'
import { showErrorSnackbar, showSuccessSnackbar } from '../../utils/snackbar'
import { messageForApiError } from '../../utils/apiErrorMessage'

export default {
  name: 'BugReportModal',
  props: {
    modelValue: Boolean,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      description: '',
      submitting: false,
    }
  },
  methods: {
    onDialogUpdate(value) {
      if (!value) {
        this.reset()
      }
      this.$emit('update:modelValue', value)
    },
    close() {
      this.$emit('update:modelValue', false)
      this.reset()
    },
    reset() {
      this.description = ''
      this.submitting = false
    },
    async submit() {
      const description = this.description.trim()
      if (!description) {
        showErrorSnackbar(this.$store, 'Please describe the bug before submitting.')
        return
      }

      this.submitting = true
      try {
        await API.bugReport.submit({
          page: window.location.href,
          description,
        })
        showSuccessSnackbar(this.$store, 'Bug successfully reported. Thank you!')
        this.close()
      } catch (err) {
        showErrorSnackbar(this.$store, messageForApiError(err, 'Could not submit bug report. Please try again.'), { error: err })
        this.submitting = false
      }
    },
  },
}
</script>
